import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';



type Tab = {
  id: string;
  name: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    value: null,
    tabs: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
  value: Tab["id"];
  tabs: Tab[]
};





const selectedIndex = computed(() => {

  const index = props.tabs.findIndex(tab => tab.id === props.value);
  return index === -1 ? 0 : index;
})


const highlightLeftPosition = computed(() => {

  const totalCount = props.tabs.length;
  const position = selectedIndex.value;

  const leftPosition = (100 / totalCount) * position;

  return leftPosition + "%";
})


const highlightLeftWidth = computed(() => {

  const totalCount = props.tabs.length;

  const width = 100 / totalCount;

  return width + "%";
})


function handleClick(tabId: string) {
  emit("input", tabId);
}

return { __sfc: true,props, emit, selectedIndex, highlightLeftPosition, highlightLeftWidth, handleClick }
}

})